const initialState = {
  geojson: {
    type: 'FeatureCollection',
    features: [],
  },
  geojsonConflicts: {
    type: 'FeatureCollection',
    features: [],
  },
  organization: [355], // default organization (makina) id in API
  owner: {},
  state: 100,
  properties: {
    title: null,
    description: null,
    comment: null,
    activities: [
      {
        type: '',
        eventDates: [],
        uid: 0,
        participantCount: '1',
        publicCount: '0',
        zone: [],
      },
    ],
    vehicles: {
      hasVehicles: false,
      licenses: [{
        name: '',
        owner: '',
        comment: '',
        uid: 0,
      }],
    },
    parkings: [],
    approbations: {},
    pricing: {},
  },
  isSaved: false,
  isSaving: false,
};
export default initialState;



// WEBPACK FOOTER //
// ./src/modules/userrequest-initial.js